import { createEffect as e } from "solid-js";
import { w as t, r as o } from "../../node_modules/.pnpm/@rnwonder_simple-datejs@1.0.4/node_modules/@rnwonder/simple-datejs/dist/general-BkFCKlQ-.js";
const m = (a) => (e(() => {
  const r = t(a.month(), a.year(), { weekStartDay: a.weekStartDay, locale: a.locale });
  a.setDayRowsArray(o(r, 7));
}), a.dayRowsArray);
export {
  m as createDaysArray
};
